import { render, staticRenderFns } from "./ComponentTick.vue?vue&type=template&id=41736b49"
import script from "./ComponentTick.vue?vue&type=script&lang=js"
export * from "./ComponentTick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports